/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';
import { UserRef } from './userRef';


export interface ProfileProviderPF { 
    id?: number;
    name?: string;
    cpf?: string;
    email?: string;
    phoneNumber?: string;
    cnesCode?: number;
    registerDate?: string;
    certifiedHubMedical?: boolean;
    active?: boolean;
    status?: ProfileProviderPF.StatusEnum;
    user?: UserRef;
    addresses?: Array<Address>;
    userEmail?: string;
}
export namespace ProfileProviderPF {
    export type StatusEnum = 'USER_ACTIVE' | 'USER_CADASTER_PROCESS' | 'PROVIDER_PF_ACTIVE' | 'PROVIDER_PF_EXPIRED_PLAN' | 'PROVIDER_PF_CADASTER_PROCESS' | 'PROVIDER_PJ_ACTIVE' | 'PROVIDER_PJ_EXPIRED_PLAN' | 'PROVIDER_PJ_CADASTER_PROCESS' | 'CUSTOMERSERVICE_OPENED' | 'CUSTOMERSERVICE_INCHAT' | 'CUSTOMERSERVICE_CLOSED';
    export const StatusEnum = {
        UserActive: 'USER_ACTIVE' as StatusEnum,
        UserCadasterProcess: 'USER_CADASTER_PROCESS' as StatusEnum,
        ProviderPfActive: 'PROVIDER_PF_ACTIVE' as StatusEnum,
        ProviderPfExpiredPlan: 'PROVIDER_PF_EXPIRED_PLAN' as StatusEnum,
        ProviderPfCadasterProcess: 'PROVIDER_PF_CADASTER_PROCESS' as StatusEnum,
        ProviderPjActive: 'PROVIDER_PJ_ACTIVE' as StatusEnum,
        ProviderPjExpiredPlan: 'PROVIDER_PJ_EXPIRED_PLAN' as StatusEnum,
        ProviderPjCadasterProcess: 'PROVIDER_PJ_CADASTER_PROCESS' as StatusEnum,
        CustomerserviceOpened: 'CUSTOMERSERVICE_OPENED' as StatusEnum,
        CustomerserviceInchat: 'CUSTOMERSERVICE_INCHAT' as StatusEnum,
        CustomerserviceClosed: 'CUSTOMERSERVICE_CLOSED' as StatusEnum
    };
}


